import { Tabs } from "antd";
import { TabsProps } from "antd/lib";
import { useEffect, useState } from "react";
import TermsOfService from "./terms-of-service/TermsOfService";
import PrivacyPolicy from "./privacy-policy/PrivacyPolicy";
import { moocPolicyGetAllByFilter } from "../../service/clause";
import "./clause.scss";
type ClauseProps = {
  title?: string;
};

const Clause = ({ title }: ClauseProps) => {
  const [keyActive, setKeyActive] = useState("1");
  const [allData, setAllData] = useState<any>();
  const [loading, setLoading] = useState(false);

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: "Chính sách bảo mật",
      children: (
        <PrivacyPolicy loading={loading} tab={keyActive} allData={allData} />
      ),
    },
    {
      key: "2",
      label: "Điều khoản dịch vụ",
      children: (
        <TermsOfService loading={loading} tab={keyActive} allData={allData} />
      ),
    },
  ];

  const params = new URLSearchParams(window.location.search);
  const uuid = params.get("uuid");

  // Tabs
  const onTabClick = (key: string) => {
    setKeyActive(key);
  };

  // fetch data
  const fetchData = async () => {
    setLoading(true);
    setAllData([]);
    await moocPolicyGetAllByFilter({
      type: Number(keyActive),
      enterpriseId: uuid,
    })
      .then((res) => {
        if (res.status === 200) {
          setAllData(res.data.data.content);
          setLoading(false);
        }
      })
      .finally(() => setLoading(false));
  };

  // useEffect
  useEffect(() => {
    fetchData();
  }, [keyActive]);

  useEffect(() => {
    document.body.classList.add("clause-page");

    return () => {
      document.body.classList.remove("clause-page");
    };
  }, []);

  return (
    <Tabs
      className="clause-tabs"
      defaultActiveKey="1"
      items={itemsTab}
      tabPosition={"top"}
      onTabClick={onTabClick}
    />
  );
};

export default Clause;
